import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_API || 'http://localhost:3001';

class AuthService {
  // Refresh the access token using the refresh token
  static async refreshToken() {
    try {
      const refreshToken = localStorage.getItem('refreshToken');
      
      if (!refreshToken) {
        throw new Error('No refresh token available');
      }

      const response = await axios.post(`${API_BASE_URL}/v1/auth/refresh-token`, {
        token: refreshToken
      });

      if (response.data.status && response.data.accessToken) {
        // Update tokens in localStorage
        localStorage.setItem('accessToken', response.data.accessToken);
        localStorage.setItem('refreshToken', response.data.refreshToken);
        
        console.log('Token refreshed successfully');
        return response.data.accessToken;
      } else {
        throw new Error('Invalid refresh response');
      }
    } catch (error) {
      console.error('Token refresh failed:', error);
      // Clear all auth data on refresh failure
      localStorage.clear();
      throw error;
    }
  }

  // Check if token is expired (basic check)
  static isTokenExpired(token) {
    if (!token) return true;
    
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      return payload.exp < currentTime;
    } catch (error) {
      console.error('Error parsing token:', error);
      return true;
    }
  }

  // Get current access token
  static getAccessToken() {
    return localStorage.getItem('accessToken');
  }

  // Get current refresh token
  static getRefreshToken() {
    return localStorage.getItem('refreshToken');
  }

  // Check if user is authenticated
  static isAuthenticated() {
    const token = this.getAccessToken();
    return token && !this.isTokenExpired(token);
  }

  // Logout user
  static logout() {
    localStorage.clear();
  }
}

export default AuthService; 